import { AxiosRequestConfig } from 'axios'
import { apiService } from '../api.service'
import { BASE_UAPI_URL } from '@/constants/commonStrings.constant'
import { GetAgentFeaturesByIdParams, UpdateAgentFeatureParams } from './agent.types'


const AgentService = () => {

  const getAgentFeaturesById = async (
    params: GetAgentFeaturesByIdParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    const { AgentId } = params
    const requestId = `getAgentFeaturesById_${Date.now()}`  

    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + `/agentfeatures?agentid=${AgentId}`,
      ...config,
      id: requestId,
    })
  }

  const updateAgentFeature = async (
    data: UpdateAgentFeatureParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    const { AgentId, Flags } = data
    const requestId = `updateAgentFeature_${Date.now()}`  
    console.log(data)

    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + `/agentfeatures?agentid=${AgentId}`,
      data: data,
      ...config,
      id: requestId,
    })
  } 


  return {
    getAgentFeaturesById,
    updateAgentFeature,
  }
}

export default AgentService